import React, { useState, useEffect } from "react";
import { Typography, Box, Button, Grid } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import {
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import { Routes, Route, useNavigate } from "react-router-dom";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import SnackBar from "../../Shared/Snackbar/Snackbar";
import classes from "./preferenceselectiontile.module.scss"
import { handleHistoricValue } from "../../Shared/Utill/Utills";
import { count, includes, isEmpty } from "underscore";
import { messages } from "../../Shared/Messages/ErrorMessages";
import { toUpperCaseString } from "../../Shared/Utill/Utills";


const PreferenceSelectionPopup = (props) => {
    const personDetails = useSelector((state) => state.person.personData);
    const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const dialog = useToggle();
    const history = useNavigate();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    console.log("MADE IT TO POPUP")
    console.log("check for rule data " + JSON.stringify(props.ruleData))
    const options ={month: 'short'}
    const [dropDownsReady,setDropDownsReady] = useState(false);
    const [value, setValue] = React.useState('');
    const [value2, setValue2] = React.useState();
    const [value3, setValue3] = React.useState();
    const  [nbr_days_min,setNbrDaysMin] = React.useState(); 
    const  [nbr_days_max,setNbrDaysMax] = React.useState() ; 
    const  [wkly_hrs_min,setWklyHrsMin] = React.useState();
    const  [wkly_hrs_max,setWklyHrsMax] = React.useState();
    const  [shift_len_min,setShiftLenMin] = React.useState(); 
    const  [shift_len_max,setShiftLenMax] = React.useState();
    let  dropdown_1;
    let  dropdown_2;
    let  dropdown_3;
    const [dropDown_1,setDropDown1] = React.useState([])
    const [dropDown_2,setDropDown2] = React.useState([])
    const [dropDown_3,setDropDown3] = React.useState([])
    const languageDetails = useSelector((state) => state.selectedLanguage.selectedLanguageData);
 
    // set state for showing popup
    useEffect(() => { 
      console.log(JSON.stringify(props.appControls) + " APPPPP")
      createDropDownValues(props.appControls)
      //setHistoricValues()
      console.log(" will you open the popup " + props.isPreferenceBoxOpen  )
      if (value !== undefined || value2!==undefined || value3!==undefined) {
        console.log("showing fsc data props " + (JSON.stringify(props.fscData)) )
        formatUpdate()
      }
      console.log("dropdown1 : " + dropdown_1);
      console.log("dropdown2 : "+ dropdown_2)
      console.log("dropdown3 : "+ dropdown_3)
      dialog.show();
      
    },[value,value2,value3,dropDownsReady])

    // call setHistoricValues only on page rerender, not on general state updates
    useEffect(() => {
      setHistoricValues()
    },[]) 

    // format update for selected dropdown values
    const formatUpdate = () => {
      //console.log(numDays + "NUM DAYS is fine")
      //this logic checks if the values the user inputs are empty or from the dropdown list of values.
      if (value === "RESET") {
        setNbrDaysMin(null)
        setNbrDaysMax(null) 
      } else {
        let numDays = (value !== null) && (value !== undefined)  ? value.split('-'):''
        setNbrDaysMin(numDays[0])
        setNbrDaysMax(numDays[1])
      }

      if (value2 === "RESET") {
        setWklyHrsMin(null)
        setWklyHrsMax(null)
        
      } else {
        let weeklyHrs = (value2 !== null) && (value2 !== undefined) ? value2.split('-'):''
        setWklyHrsMin(weeklyHrs[0])  
        setWklyHrsMax(weeklyHrs[1]) 
      }

      if (value3 === "RESET") {
        setShiftLenMin(null)
        setShiftLenMax(null)
        
      } else {
        let dailyShiftLength = (value3 !== null) && (value3 !== undefined) ? value3.split('-'):''   
        setShiftLenMin(dailyShiftLength[0])  
        setShiftLenMax(dailyShiftLength[1]) 
      }
    /*  let numDays = (value !== null) && (value !== undefined)  ? value.split('-'):''
      let weeklyHrs = (value2 !== null) && (value2 !== undefined) ? value2.split('-'):''
      let dailyShiftLength = (value3 !== null) && (value3 !== undefined) ? value3.split('-'):''*/
     
      
      
      console.log(nbr_days_min + " is split " + nbr_days_max)
      console.log(wkly_hrs_min + " is split " + wkly_hrs_max)
      console.log(shift_len_min + " is split " + shift_len_max)
    }

    const formatMonth = (input) => 
  {
    const d = new Date(input)
    const s = d.toLocaleDateString('en-US', options)
    console.log(s + "-------")
    return s
  }

  const formatDate = (input) => 
  {
    console.log(new Date(input).getUTCDate() + "-------")
    return new Date(input).getUTCDate()
  }

  // historic value set
  const setHistoricValues = () => {
    if(props.weeklyData.avlPWH_nbr_days_min!=null) {
      console.log("checking for nbrdays match!")
       let historicMinDays = props.weeklyData.avlPWH_nbr_days_min+" - " + props.weeklyData.avlPWH_nbr_days_max
     // let historicMinDays = "0 - 2"
       for (let i = 0; i < dropdown_1.length; i++) {
        
        if (historicMinDays===dropdown_1[i]) {
          console.log("Found a match at index : "+ i)
          setValue(historicMinDays)
        } 
       } // for
    } // nbrDays comparison

    if(props.weeklyData.avlPWH_wkly_hrs_min!=null) {
      console.log("checking for weeklyhrs match!")
       let historicMinDays = props.weeklyData.avlPWH_wkly_hrs_min+" - " + props.weeklyData.avlPWH_wkly_hrs_max
     // let historicMinDays = "0 - 4"
       for (let i = 0; i < dropdown_2.length; i++) {
        if (historicMinDays===dropdown_2[i]) {
          console.log("Found a match at index : "+ i)
          setValue2(historicMinDays)
        } 
       } // for
    } // nbrDays comparison


    if(props.weeklyData.avlPWH_shift_len_min!=null) {
      console.log("checking for shift match!")
       let historicMinDays = props.weeklyData.avlPWH_shift_len_min+" - " + props.weeklyData.avlPWH_shift_len_max
     // let historicMinDays = "0 - 2"
       for (let i = 0; i < dropdown_3.length; i++) {
        if (historicMinDays===dropdown_3[i]) {
          console.log("Found a match at index : "+ i)
          setValue3(historicMinDays)
        } 
       } // for
    } // nbrDays comparison
    
  }

    // updateHandler
    const handleSave = () => {

      if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
        setAlertOpen({
          open: true,
          severity: 'error',
          message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,        })
        return;
      }
      
      let data = {
        ascNbr: personDetails.emplID,
        // myDiv: personDetails.mydiv,
        // myStore: personDetails.mystore,
        // myDept: personDetails.mydept,
        myDiv: personODSFuture.mydiv,
        myStore: personODSFuture.mystore,
        myDept: personODSFuture.mydept,
        fscyyyy: props.fscData.fscYyyy,
        fscww: props.fscData.fscWw,
        arId: props.ruleData.arId,
        avlId: props.weeklyData.avlId,
        avlRuleId: props.ruleData.ruleId,
        avlTermed: props.weeklyData.avlTermed,
        avlPWH_nbr_days_min: nbr_days_min,
        avlPWH_nbr_days_max: nbr_days_max,
        avlPWH_wkly_hrs_min: wkly_hrs_min,
        avlPWH_wkly_hrs_max: wkly_hrs_max,
        avlPWH_shift_len_min: shift_len_min,
        avlPWH_shift_len_max: shift_len_max,
        avlPWH_base: props.weeklyData.avlPWH_base,
        avlPWH_override: props.weeklyData.avlPWH_override,
        lastUpdatedBy: personDetails.emplID,
        impersonatedBy: null,
        checkRulesOnly:"N",
        ruleToCheck:"ALL",
        avlLanguageCode: languageDetails.selected !== '' ? languageDetails.selected : 'en'        

    }
          axios({
            url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_OR_INSERT_WD}`,
            method: "POST",
            data: data,
            headers:{
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' + colleagueTKN,
            },
            
          })
            .then((res) => {
            console.log("Response " + res.status)
            props.successOnUpdate("success")
            props.PreferencePopupClose()
            })
            .catch((err) => {
              setAlertOpen({
                open: true,
                severity: "error",
                message : "Please logout and try again",
              })
        });
    } // handle save

    // util task for mapping json values to fill appropriate dropdowns
    const createDropDownValues = (jsArray) => {
      console.log(JSON.stringify(jsArray) + "this is what i need to check for")
     dropdown_1 =  jsArray.map(e => nbrDaysDropDown(e))
     dropdown_2 =  jsArray.map(e => wklyHrsDropDown(e))
     dropdown_3 =  jsArray.map(e => shiftHrsDropDown(e))
     
     dropdown_1 = dropdown_1.filter(e => {return e != null && e!= ''});
     dropdown_2 = dropdown_2.filter(e => {return e != null && e!= ''});
     dropdown_3 = dropdown_3.filter(e => {return e != null && e!= ''});
     
     /*console.log(JSON.stringify(dropDown_1) + "THIS IS A CHECK")
     console.log((dropDown_1[0]) + " lol")*/
     console.log(JSON.stringify(dropDown_2) + "check dpd")
     if (!isEmpty(dropDown_1) ) {
      
      dropdown_1.splice(0,0,'RESET')
     }
     if (!isEmpty(dropDown_2)) {
      dropdown_2.splice(0,0,'RESET')
     }
    if (!isEmpty(dropDown_3)) {
      dropdown_3.splice(0,0,'RESET')
    }
    console.log(JSON.stringify(dropDown_2) + "check dpd2")
     setDropDown1(dropdown_1)
     setDropDown2(dropdown_2)
     setDropDown3(dropdown_3)
     setDropDownsReady(true)
    }
    const nbrDaysDropDown = (element) => {
      let dropDownValue;
      if (element.ctlName.indexOf("ddnbrdays") > -1) {
        if ( (element.ctlValue01 === "") || (element.ctlValue02 === "")  ) {
          console.log("we are MISSING SOMETHING")
          return null;
        } else {
          dropDownValue = element.ctlValue01 + " - " + element.ctlValue02
          return dropDownValue
        }
      }
     }


     const wklyHrsDropDown = (element) => {
      let dropDownValue;
      if (element.ctlName.indexOf("ddwklyrs") > -1) {
        if ( (element.ctlValue01 === "") || (element.ctlValue02 === "")  ) {
          console.log("we are MISSING SOMETHING")
          return null;
        } else {
          dropDownValue = element.ctlValue01 + " - " + element.ctlValue02
          return dropDownValue
        }
      }
     }


     const shiftHrsDropDown = (element) => {
      let dropDownValue;
      if (element.ctlName.indexOf("ddshifthrs") > -1) {
        if ( (element.ctlValue01 === "") || (element.ctlValue02 === "")  ) {
          console.log("we are MISSING SOMETHING")
          return null;
        } else {
          dropDownValue = element.ctlValue01 + " - " + element.ctlValue02
          return dropDownValue
        }
      }
     }

    const handleNumofDaysChange = (event) => {
      console.log(event.target.value + " attempt to update")
      setValue(event.target.value);
    };
    const handleTotalWeeklyHoursChange = (event) => {
      setValue2(event.target.value);
    };
    const handleDailyShiftHoursChange = (event) => {
      setValue3(event.target.value);
    };

    const handleAlertNotifClose = () => {
      setAlertOpen({});
    };

    /*Need 2 check if we adjust historical dropdown value to fit next smallest range in dropdown list.
    If no adjustment is needed then just proceed as expected.
    */
    const getDialogStyleVersion = () => {
      let widthD = "45%";
      let leftMargin = "45%";
      if(window.innerWidth < 768){
          //mobile version
          widthD = "100%";
          leftMargin = "0%";
        }else if(window.innerWidth <= 1300){
          // tablet
          widthD = "75%";
          leftMargin = "13%";
        }else if(window.innerWidth > 1300){
          //desktop
          widthD = "45%";
          leftMargin = "28%";
        }
      return {
          width: widthD,
          maxWidth: widthD,
          display:"flex",
          left:leftMargin,
          minHeight: "100%", 

      }
  }

return (
  
  <div className="dialog" >
    <Dialog className={classes.dialog}
        PaperProps={{
                sx: getDialogStyleVersion(),
            }}
        open={dialog.open}
        title='Preferences'
        onClose={props.PreferencePopupClose}      
      >
        <div className={classes.dialog_content}>
        <Typography>
        <span className={classes.headingDate}>{"Sunday, "+formatMonth(props.bow)+" "+formatDate(props.bow) + " - Saturday, " + formatMonth(props.eow) +" "+ formatDate(props.eow) }
        </span></Typography>
        <div className={classes.rows}>

        <FormControl className={classes.row}>
          <InputLabel id="demo-select-basic-label">No. of Days</InputLabel>
          <Select
            labelId="demo-select-basic-label"
            id="demo-select-basic"
            label="No. of Da"
            value = {value}
            onChange={handleNumofDaysChange}
            >
        
        {dropDown_1 && dropDown_1.map(e1 => <MenuItem value={e1}>{e1}</MenuItem> )}
        
        </Select>
      </FormControl>

      <FormControl className={classes.row}>
          <InputLabel id="demo-select-basic-label">Total Weekly Hours</InputLabel>
          <Select
            labelId="demo-select-basic-label"
            id="demo-select-basic"
            label="Total Weekly H"
            value= {value2}
            onChange={handleTotalWeeklyHoursChange}
          >
        {dropDown_2 && dropDown_2.map(e2 => <MenuItem value={e2}>{e2}</MenuItem> )}
        </Select>
      </FormControl>


      <FormControl className={classes.row}>
          <InputLabel id="demo-select-basic-label">Daily Shift Length Hours</InputLabel>
          <Select
            labelId="demo-select-basic-label"
            id="demo-select-basic"
            label="Daily Shift LengthH"
            value={value3}
            onChange={handleDailyShiftHoursChange}
          >
        {dropDown_3 && dropDown_3.map(e3 => <MenuItem value={e3}>{e3}</MenuItem> )}
        </Select>
      </FormControl>

      <Grid style={{marginTop: '30px'}} container spacing={2}>
        <Grid item xs={12} md={6} sm={6}>
            <Button  style={{width: '100%', padding: '10px'}} color="secondary" onClick={props.PreferencePopupClose}>Cancel</Button>
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
            <Button  style={{width: '100%', padding: '10px'}} onClick={handleSave} >Save</Button>
            </Grid>
      </Grid>
        </div>
        </div>
      <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar> 
      </Dialog>
      </div>
)

}

export default PreferenceSelectionPopup;